import * as echarts from 'echarts/core'
import VChart from 'vue-echarts'
import type { Plugin } from 'vue'

import {
  LineChart,
  type LineSeriesOption,
  BarChart,
  type BarSeriesOption,
  CustomChart,
  type CustomSeriesOption,
  EffectScatterChart,
  type EffectScatterSeriesOption,
  ScatterChart,
  type ScatterSeriesOption,
  PieChart,
  type PieSeriesOption,
  RadarChart,
  type RadarSeriesOption,
  SankeyChart,
  type SankeySeriesOption,
} from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import {
  DataZoomComponent,
  type DataZoomComponentOption,
  LegendComponent,
  type LegendComponentOption,
  TooltipComponent,
  type TooltipComponentOption,
  ToolboxComponent,
  type ToolboxComponentOption,
  GridComponent,
  type GridComponentOption,
  TitleComponent,
  type TitleComponentOption,
  MarkPointComponent,
  type MarkPointComponentOption,
  MarkLineComponent,
  type MarkLineComponentOption,
  MarkAreaComponent,
  type MarkAreaComponentOption,
  DatasetComponent,
  type DatasetComponentOption,
  VisualMapComponent,
  type VisualMapComponentOption,
} from 'echarts/components'

echarts.use([
  LineChart,
  BarChart,
  CustomChart,
  PieChart,
  RadarChart,
  EffectScatterChart,
  ScatterChart,
  SankeyChart,
  CanvasRenderer,
  DataZoomComponent,
  LegendComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
  TitleComponent,
  MarkPointComponent,
  MarkLineComponent,
  MarkAreaComponent,
  DatasetComponent,
  VisualMapComponent,
])

export type ECOption = echarts.ComposeOption<
  | LineSeriesOption
  | BarSeriesOption  | CustomSeriesOption  | PieSeriesOption
  | RadarSeriesOption
  | EffectScatterSeriesOption
  | ScatterSeriesOption
  | SankeySeriesOption
  | DataZoomComponentOption
  | LegendComponentOption
  | TooltipComponentOption
  | ToolboxComponentOption
  | GridComponentOption
  | TitleComponentOption
  | MarkPointComponentOption
  | MarkLineComponentOption
  | MarkAreaComponentOption
  | DatasetComponentOption
  | VisualMapComponentOption
>

export default {
  install(app) {
    app.component('VChart', VChart)
  },
} satisfies Plugin
